import {
  DetectionConfigurationData,
  DropdownOption,
  ExternalUserFieldAccess,
  FormField,
  getNumberFieldByDataKey,
  getStringFieldByDataKey,
  InputType,
} from 'types'
import {
  optionalStringSchema,
  requiredNumberSchema,
  requiredStringSchema,
} from 'utils/zodHelpers'

export interface DetectionConfigurationFormData {
  configName: string
  targetSensorId: string
  pollingFrequency: number
  isEnabled: string
}

export const DetectionConfigurationFormFields = ({
  data,
  sensorOptions,
}: {
  data: DetectionConfigurationFormData
  sensorOptions: DropdownOption[]
}): FormField[] => {
  return [
    {
      dataKey: 'configName',
      label: 'Configuration Name',
      value: data.configName,
      unit_magnitude: null,
      validationRule: optionalStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Text,
    },
    {
      dataKey: 'targetSensorId',
      label: 'Target Sensor',
      value: data.targetSensorId,
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Dropdown,
      options: sensorOptions,
    },
    {
      dataKey: 'pollingFrequency',
      label: 'Polling Frequency (minutes)',
      value: data.pollingFrequency,
      unit_magnitude: null,
      validationRule: requiredNumberSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Number,
    },
    {
      dataKey: 'isEnabled',
      label: 'Enable Monitoring',
      value: data.isEnabled,
      unit_magnitude: null,
      validationRule: requiredStringSchema,
      externalUserAccess: ExternalUserFieldAccess.ReadWrite,
      isNeededForDerivedLayer: false,
      inputType: InputType.Dropdown,
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  ]
}

export const DetectionConfigurationDataFromFormFields = (
  formFields: FormField[]
): Omit<DetectionConfigurationData, 'detection_models'> => {
  return {
    name: getStringFieldByDataKey(formFields, 'configName') ?? '',
    target_sensor_entry_id:
      getStringFieldByDataKey(formFields, 'targetSensorId') ?? '',
    polling_frequency_minutes:
      getNumberFieldByDataKey(formFields, 'pollingFrequency') ?? 5,
    is_enabled: getStringFieldByDataKey(formFields, 'isEnabled') === 'yes',
  }
}
